import { useQuery } from '@tanstack/react-query';
import {PressureReading} from "@/types/sensors";
import {sensorsService} from "@/services/sensors";

/**
 * Hook pour récupérer la pression atmosphérique actuelle
 *
 * Refetch automatique toutes les 5 minutes
 * Cache pendant 2 minutes
 */
export const usePressure = () => {
  return useQuery<PressureReading, Error>({
    queryKey: ['sensors', 'pressure', 'current'],
    queryFn: sensorsService.getCurrentPressure,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
};